import mapFunction from './mapResources';

export default mapFunction('order_material_quantity', {
    isFetching: false,
    items: []
});